import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../../API";
import { isAutheticated } from "../auth/authhelper";
import Footer from "./Footer";


import { Container, Row, Col, Card } from "react-bootstrap";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, LineChart, Line, PieChart, Pie, Cell,
} from "recharts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AF19FF"];
// import Header from "./Header";
// import Sidebar from "./Sidebar";

export default function Dashboard() {
  const [data, setData] = useState({
    picture: "",
    facebookLink: "",
    twitterLink: "",
    websiteLink: "",
    linkedinLink: "",
    fees: "",
    username: "",
  });

  const [paypal, setPaypal] = useState({});
  const [stripe, setStripe] = useState({});
  const [video, setVideo] = useState("");
  const [subscribers, setSubscribers] = useState("");
  const [product, setProduct] = useState("");
  const [tvShow, setTvShow] = useState("");
  const [paypalDataLoaded, setPaypalDataLoaded] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  //Analytics
  const [totalVisitors, setTotalVisitors] = useState(0);
  const [mostVisitedPages, setMostVisitedPages] = useState([]);
  const [searchTrends, setSearchTrends] = useState([]);
  const [activity, setActivity] = useState([]);
  const [dailyVisitors, setDailyVisitors] = useState([]);
  const [browserStats, setBrowserStats] = useState([]);
  const [deviceStats, setDeviceStats] = useState([]);
  const [countryStats, setCountryStats] = useState([]);
  const [sessionDuration, setSessionDuration] = useState(0);
  // 
  const { token } = isAutheticated();
  useEffect(() => {
    axios
      .get(`${API}/api/user/payments`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const getData = response.data.data;
        //console.log("payment",getData);
        setPaypal(getData.paypal);
        setStripe(getData.stripe);
        setPaypalDataLoaded(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    axios
      .get(`${API}/api/user/details`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const getData = response.data.data;
        console.log(getData);
        //console.log("deatails",getData);
        setProduct(getData.productsCount);
        setSubscribers(getData.subscriberCount);
        setTvShow(getData.tvshowsCount);
        setVideo(getData.videosCount);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    // $("#summernote").summernote();

    axios
      .get(`${API}/api/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const userdata = response.data.data;
        setData({
          ...data,
          picture: userdata.picture,
          twitterLink: userdata.twitterLink,
          linkedinLink: userdata.linkedinLink,
          facebookLink: userdata.facebookLink,
          fees: userdata.fees,
        });
        setDataLoaded(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  //Analitics
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [visitors, pages, searches, act, daily, browsers, devices, countries, session] = await Promise.all([
          axios.get(`${API}/api/analytics/total-visitors`),
          axios.get(`${API}/api/analytics/most-visited`),
          axios.get(`${API}/api/analytics/search-trends`),
          axios.get(`${API}/api/analytics/activity`),
          axios.get(`${API}/api/analytics/daily-visitors`),
          axios.get(`${API}/api/analytics/browser-stats`),
          axios.get(`${API}/api/analytics/device-stats`),
          axios.get(`${API}/api/analytics/country-stats`),
          axios.get(`${API}/api/analytics/session-duration`),
        ]);
        console.log("visitors.data", visitors.data)
        console.log("pages.data", pages.data)
        console.log("Top Searches", searches.data)


        setTotalVisitors(visitors.data.totalVisitors);
        setMostVisitedPages(pages.data);
        setSearchTrends(searches.data);
        setActivity(act.data);
        setDailyVisitors(daily.data);
        setBrowserStats(browsers.data);
        setDeviceStats(devices.data);
        setCountryStats(countries.data);
        setSessionDuration(session.data.avgDuration);
      } catch (error) {
        console.error("Error fetching analytics data", error);
      }
    };

    fetchData();
  }, []);
  // -----------------------------------------------------------------//
  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          {/* <div className='row'>
            <div className='col-12'>
              <div
                className='
                    page-title-box
                    d-flex
                    align-items-center
                    justify-content-between
                  '>
                <h4 className='mb-0'>Dashboard</h4>

                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='#'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item active'>Dashboard</li>
                  </ol>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className='row'>
            <div className='col-lg-12 mb-30'>
              <div className='card dashboard-box'>
                <div className='card-body'>
                  <div className='row'>
                    <div className='col-lg-4 mb-0'>
                      <div className='media statistics'>
                        <span>
                          <img
                            src='assets/images/icons/earning-icon2.png'
                            alt=''
                          />
                        </span>
                        <div className='media-body align-self-center overflow-hidden'>
                          <div className='text-left'>
                            <h4 className='text-truncate'>Total Products</h4>
                            <h1>
                              {product}
                            </h1>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='col-lg-4 mb-10'>
                      <div className='media statistics'>
                        <span>
                          <img
                            src='assets/images/icons/views-icon.png'
                            alt=''
                          />
                        </span>
                        <div className='media-body align-self-center overflow-hidden'>
                          <div className='text-left'>
                            <h4 className='text-truncate'>Total Movies</h4>
                            <h1>{video}</h1>
                          </div>
                        </div>
                      </div>
                    </div>
                    

                    <div className='col-lg-4 mb-10'>
                      <div className='media statistics'>
                        <span>
                          <img
                            src='assets/images/icons/reviews-icon.png'
                            alt=''
                          />
                        </span>
                        <div className='media-body align-self-center overflow-hidden'>
                          <div className='text-left'>
                            <h4 className='text-truncate'>Total Subscribers</h4>
                            <h1>{subscribers}</h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className='row'>
            {paypalDataLoaded &&
              (!paypal.permissionsGranted || !paypal.ENABLED) &&
              (!stripe.details_submitted || !stripe.ENABLED) && (
                <div className='col-lg-4 mb-30'>
                  <div className='card dashboard-box'>
                    <div className='card-body'>
                      <div className='media'>
                        <div className='media-body align-self-center overflow-hidden'>
                          <div className='text-center'>
                            <img
                              src='assets/images/icons/payout-icon.png'
                              alt=''
                              className='avatar-md'
                            />
                            <h5 className='text-truncate'>
                              Connect a payout method
                            </h5>
                            <p>
                              Your page is currently private. Connect your
                              PayPal or Stripe account to start receiving
                              payments.
                            </p>
                            <div className='form-group m-0'>
                              <Link to='/payment'>
                                <button
                                  type='button'
                                  className='
                                  btn btn-dashboard
                                  waves-effect waves-light
                                '
                                  style={{ backgroundColor: "blueviolet" }}>
                                  Connect
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}

          {/* {dataLoaded && data.picture == "" && (
              <div className='col-lg-4 mb-30'>
                <div className='card dashboard-box'>
                  <div className='card-body'>
                    <div className='media'>
                      <div className='media-body align-self-center overflow-hidden'>
                        <div className='text-center'>
                          <img
                            src='assets/images/icons/profile-page-icon.png'
                            alt=''
                            className='avatar-md'
                          />
                          <h5 className='text-truncate'>Complete your page</h5>
                          <p>
                            Add a photo, one-liner, and a little bit about you.
                            See some beautiful examples here, here, and here.
                          </p>
                          <div className='form-group m-0'>
                            <a href='profile.html'>
                              <button
                                type='button'
                                className='
                                  btn btn-dashboard
                                  waves-effect waves-light
                                '>
                                Connect
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )} */}

          {/* {dataLoaded && data.fees == 0 && (
              <div className='col-lg-4 mb-30'>
                {console.log(data.fees)}
                <div className='card dashboard-box'>
                  <div className='card-body'>
                    <div className='media'>
                      <div className='media-body align-self-center overflow-hidden'>
                        <div className='text-center'>
                          <img
                            src='assets/images/icons/setgoal-icon.png'
                            alt=''
                            className='avatar-md'
                          />
                          <h5 className='text-truncate'>
                            Set a goal - Set price for consulting
                          </h5>
                          <p>
                            Pages with goals consistently attract more
                            supporters. Add some goals and let them be a part of
                            your creative journey.
                          </p>

                          <div className='form-group m-0'>
                            <a href='payment-setting.html'>
                              <button
                                type='button'
                                className='
                                  btn btn-dashboard
                                  waves-effect waves-light
                                '>
                                Connect
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )} */}

          {/* {data.facebookLink == "" &&
              data.linkedinLink == "" &&
              data.websiteLink &&
              data.twitterLink == "" && (
                <div className='col-lg-4 mb-30'>
                  <div className='card dashboard-box'>
                    <div className='card-body'>
                      <div className='media'>
                        <div className='media-body align-self-center overflow-hidden'>
                          <div className='text-center'>
                            <img
                              src='assets/images/icons/social-iocn.png'
                              alt=''
                              className='avatar-md'
                            />
                            <h5 className='text-truncate'>
                              Link from your social bio and descriptions
                            </h5>
                            <p>
                              Keep your BMC link where your followers can find
                              them. Most creators add it as their primary bio
                              link on Twitter, Instagram, Linktree, Youtube
                              description, etc.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}

          {/* <div className="col-lg-4 mb-30">
              <div className="card dashboard-box">
                <div className="card-body">
                  <div className="media">
                    <div className="media-body align-self-center overflow-hidden">
                      <div className="text-center">
                        <img
                          src="assets/images/icons/announce-page-icon.png"
                          alt=""
                          className="avatar-md"
                        />

                        <h5 className="text-truncate">Announce your page</h5>
                        <p>
                          This is usually how creators earn their first set of
                          supporters. Make it unique, and maybe even offer
                          something in return. See some examples here.
                        </p>
                        <div className="form-group text-left m-0">
                          <a href="#">
                            <button
                              type="button"
                              className="
                                  btn btn-dashboard
                                  waves-effect waves-light
                                "
                            >
                              Tweet
                            </button>
                          </a>
                          <a href="#">
                            <button
                              type="button"
                              className="
                                  btn btn-dashboard
                                  waves-effect waves-light
                                "
                            >
                              Share
                            </button>
                          </a>

                          <a href="#">
                            <button
                              type="button"
                              className="
                                  btn btn-dashboard
                                  waves-effect waves-light
                                "
                            >
                              Gifs
                            </button>
                          </a>

                          <a href="#">
                            <button
                              type="button"
                              className="
                                  btn btn-dashboard
                                  waves-effect waves-light
                                "
                            >
                              Download Creator Kit
                            </button>
                          </a>
                        </div>

                        <div className="form-group text-left mt-3">
                          <div className="input-group mb-3">
                            <input
                              type="text"
                              className="form-control input-field"
                              placeholder="Url Of user"
                            />
                            <div className="input-group-append">
                              <button className="btn btn-primary" type="button">
                                Copy
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          {/* </div> */}

          {/* Analitics */}
          <Container className="py-4">
            <h2 className="text-center mb-4">📊 Admin Analytics</h2>
            <Row className="g-4">
              <Col md={6}>
                <Card className="p-3 text-white bg-primary">
                  <h4>Total Visitors</h4>
                  <h2>{totalVisitors}</h2>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="p-3 text-dark bg-warning">
                  <h4>Avg. Session Duration</h4>
                  <h2>{sessionDuration.toFixed(2)} sec</h2>
                </Card>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col lg={6} sm={12}>
                <h4>📌 Most Visited Pages</h4>
                <BarChart width={500} height={300} data={mostVisitedPages}>
                  <XAxis dataKey="_id" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="count" fill="#0088FE" />
                </BarChart>
              </Col>
              <Col lg={6} sm={12}>
                <h4>🔍 Top Search Trends</h4>
                <BarChart width={500} height={300} data={searchTrends}>
                  <XAxis dataKey="_id" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="count" fill="#FFBB28" />
                </BarChart>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col lg={6} sm={12}>
                <h4>📈 User Activity Over Time</h4>
                <LineChart width={500} height={300} data={activity}>
                  <XAxis dataKey="_id" />
                  <YAxis />
                  <Tooltip />
                  <Line type="monotone" dataKey="count" stroke="#00C49F" />
                </LineChart>
              </Col>
              <Col lg={6} sm={12}>
                <h4>📅 Daily Unique Visitors</h4>
                <LineChart width={500} height={300} data={dailyVisitors}>
                  <XAxis dataKey="_id" />
                  <YAxis />
                  <Tooltip />
                  <Line type="monotone" dataKey="uniqueVisitors" stroke="#AF19FF" />
                </LineChart>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col lg={6} sm={12}>
                <h4>🌐 Browser Usage</h4>
                <PieChart width={400} height={300}>
                  <Pie data={browserStats} dataKey="count" nameKey="_id" cx="50%" cy="50%" outerRadius={80}>
                    {browserStats.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </Col>
              <Col lg={6} sm={12}>
                <h4>📱 Device Usage</h4>
                <PieChart width={400} height={300}>
                  <Pie data={deviceStats} dataKey="count" nameKey="_id" cx="50%" cy="50%" outerRadius={80}>
                    {deviceStats.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </Col>
            </Row>

            <Row className="mt-4">
              <Col>
                <h4>🌍 Visitors by Country</h4>
                <BarChart width={600} height={300} data={countryStats}>
                  <XAxis dataKey="_id" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="count" fill="#00C49F" />
                </BarChart>
              </Col>
            </Row>
          </Container>
          {/*  */}
        </div>
      </div>

      <Footer />
    </div>
  );
}
